import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import type { AddTripFormValues } from '../FormValues';
import { useIsSelectedTripInThePast } from '../useIsSelectedTripInThePast';
import { MakeAdditionalLegButton } from './MakeAdditionalLegButton';
import { MakeRoundTripButton } from './MakeRoundTripButton';
import { MakeWaitAndReturnButton } from './MakeWaitAndReturnButton';
import { TripLeg } from './TripLeg';
import { useTripFieldArray } from './useTripFieldArray';
import { useAppSelector } from 'src/app/store/hooks';

export function TripDetailsFormBody() {
  const { fields } = useTripFieldArray();
  const { getValues } = useFormContext<AddTripFormValues>();
  const { id, trips } = getValues();

  const selectedTrip = useAppSelector((state) => state.addATrip.selectedTrip);
  const isSelectedTripInThePast = useIsSelectedTripInThePast();

  const canAddAdditionalLegs = useMemo(() => {
    const isWaitAndReturn =
      trips[0].is_wait_and_return_outbound ||
      trips[0].is_wait_and_return_inbound;
    return !id || (id && trips.length < 2 && !isWaitAndReturn);
  }, [id, trips]);

  return (
    <div className="flex flex-col gap-y-2">
      {fields.map((field, index) => {
        if (!trips[index]) {
          return null;
        }
        return <TripLeg index={index} field={field} key={field.id} />;
      })}
      {canAddAdditionalLegs && !isSelectedTripInThePast && (
        <div className="mt-6 flex items-center justify-between gap-x-4">
          <MakeRoundTripButton isWillCall={false} />
          <MakeRoundTripButton isWillCall />
          <MakeAdditionalLegButton />
          {(!selectedTrip || selectedTrip.status === 'pending') && (
            <MakeWaitAndReturnButton />
          )}
        </div>
      )}
    </div>
  );
}
